import { CustomEquipmentTypeDao, EquipmentTypeCandidateDao } from '@rock/db-admin';
import type { CustomEquipmentType, EquipmentTypeCandidateId, EquipmentTypeId, HomeId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const candidateDao = new EquipmentTypeCandidateDao();
const customEquipmentTypeDao = new CustomEquipmentTypeDao();

export const equipmentTypeCandidatesState = candidateDao.candidatesAtom();

export const equipmentTypeCandidateState = atomFamily(
    (candidateId: EquipmentTypeCandidateId) => candidateDao.candidateAtom(candidateId),
    shallowEqual,
);

// Customs linked to a candidate, fetched once when the detail page mounts.
export const customsForCandidateState = atomFamily(
    (candidateId: EquipmentTypeCandidateId) =>
        atom(async (): Promise<CustomEquipmentType[]> => customEquipmentTypeDao.listCustomsByCandidateId(candidateId)),
    shallowEqual,
);

/** One home's custom-type doc (live) — the model page's custom-type banner resolves title + candidate. */
export const customEquipmentTypeState = atomFamily(
    (key: { homeId: HomeId; typeId: EquipmentTypeId } | undefined) =>
        key
            ? customEquipmentTypeDao.customEquipmentTypeAtom(key.homeId, key.typeId)
            : atom(async (): Promise<CustomEquipmentType | undefined> => undefined),
    shallowEqual,
);
